import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class MissingAccountLookup extends ModelBase {

    public staticServiceProviderFileGroupingId: number = 0;

    public staticServiceProviderId: number = 0;

    public stockbroker: string | null = null;

    public serviceProvider: string | null = null;

    public accountReference: string | null = null;

    public alternativeAccountReference: string | null = null;

    public clientAltSearch: boolean = false;

    public missingAccountId: number = 0;
}